function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { useContext } from "react";
import PropTypes from "prop-types";
import useTheme from "./useTheme";
import { DEFAULT_BREAKPOINT } from "../utils/css";
import { jsx as ___EmotionJSX } from "@emotion/core";

function getInputColor(backgroundColor) {
  return [undefined, "transparent", "white"].includes(backgroundColor) ? "grey.t05" : "white";
}

export function mapResponsiveValues(map, mapFn, theme) {
  if (map) {
    var _result = _defineProperty({}, DEFAULT_BREAKPOINT, mapFn(map[DEFAULT_BREAKPOINT]));

    for (var bp in theme.breakpoints) {
      _result[bp] = mapFn(map[bp]);
    }

    return _result;
  }

  var defaultValue = mapFn();

  var result = _defineProperty({}, DEFAULT_BREAKPOINT, defaultValue);

  for (var _bp in theme.breakpoints) {
    result[_bp] = defaultValue;
  }

  return result;
}

function getBgMapFromValue(value, theme) {
  var result = _defineProperty({}, DEFAULT_BREAKPOINT, value);

  for (var bp in theme.breakpoints) {
    result[bp] = value;
  }

  return result;
}

var BackgroundContext = /*#__PURE__*/React.createContext();
export function BackgroundProvider(_ref) {
  var value = _ref.value,
      children = _ref.children;
  var theme = useTheme();
  var bgMap = _typeof(value) === "object" ? value : getBgMapFromValue(value, theme);
  return ___EmotionJSX(BackgroundContext.Provider, {
    value: bgMap
  }, children);
}
BackgroundProvider.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node
};

function useBackground() {
  var theme = useTheme();
  var bgMap = useContext(BackgroundContext);
  var inputColorMap = mapResponsiveValues(bgMap, getInputColor, theme);
  return {
    bgMap: bgMap,
    inputColorMap: inputColorMap
  };
}

export default useBackground;